import React from 'react';
import {
    COVER_DISPLAY_FONT_VAR,
    CoverLogo,
    CoverMetaSmall,
    coverTitleSize,
    type CoverTemplateProps,
} from './shared';

const AURORA_BACKGROUND = [
    'radial-gradient(ellipse 62% 42% at 16% 12%, rgba(158, 179, 148, 0.42), transparent 70%)',
    'radial-gradient(ellipse 58% 40% at 88% 34%, rgba(169, 192, 216, 0.5), transparent 72%)',
    'radial-gradient(ellipse 70% 38% at 50% 102%, rgba(226, 205, 186, 0.5), transparent 74%)',
].join(', ');

/**
 * Gradiente suave: brilhos radiais em sálvia/azul/terracota sobre off-white.
 * Paleta própria — ignora as cores da marca de propósito.
 */
export const Aurora: React.FC<CoverTemplateProps> = ({ fields, logoUrl, showLogo }) => (
    <div
        className="flex size-full flex-col items-center px-[2.6em] pb-[2.8em] pt-[3em] text-center text-[#2b3037]"
        style={{ background: `${AURORA_BACKGROUND}, #f7f6f2` }}
    >
        <CoverLogo logoUrl={logoUrl} showLogo={showLogo} className="h-[2.4em]" />
        <div className="my-auto flex flex-col items-center">
            <div
                className="font-bold leading-[1.08] tracking-[-0.015em]"
                style={{
                    fontFamily: COVER_DISPLAY_FONT_VAR,
                    fontSize: coverTitleSize(2.6),
                }}
            >
                {fields.document_title}
            </div>
            {fields.subtitle ? (
                <div
                    className="mt-[1.9em] uppercase tracking-[0.32em] text-[#6c7370]"
                    style={{ fontSize: coverTitleSize(0.6) }}
                >
                    {fields.subtitle}
                </div>
            ) : null}
            <div className="mt-[1.7em] h-[2px] w-[2em] rounded-[2px] bg-[#7f947c]" />
        </div>
        <CoverMetaSmall fields={fields} dimColor="#6c7370" />
    </div>
);
